import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { VoterProxyDecision, IApiResponseModel } from '../../types/voteTypes';
import { LoadingButton } from '../common/LoadingButton';
import { ErrorBanner } from '../common/ErrorBanner';
import { SuccessBanner } from '../common/SuccessBanner';
import { useVoting } from '../../contexts/VotingContext';

export const ProxyNomination: React.FC = () => {
    const [isProxy, setIsProxy] = useState(false);
    const [proxyEmail, setProxyEmail] = useState('');
    const [isSubmitting, setSubmitting] = useState(false);
    const [isJustSubmitted, setJustSubmitted] = useState(false);
    const [isPreview, setPreview] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string>('')
    const [successMsg, setSuccessMsg] = useState<string>('')

    const { ballot, voter, proxyInfo } = useVoting();

    useEffect(() => {
        if (!voter) {
            return
        }
        setIsProxy(voter.proxyDecision === VoterProxyDecision.Proxy || voter.proxyDecision === VoterProxyDecision.DirectedProxy)
        setProxyEmail(voter.proxyEmail)
    }, [voter])

    // Shouldn't get to this but need to be checked because useVoting context
    if (!ballot || !voter || !proxyInfo) {
        return <></>;
    }

    const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsProxy(e.target.value === 'proxy');
        if (e.target.value !== 'proxy') {
            setProxyEmail(''); // Reset email if not using proxy
        }
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setProxyEmail(e.target.value);
    };

    const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
        setSubmitting(true)
        axios.post<IApiResponseModel>('/vote/submitProxy', {
            id: voter.uniqueId,
            key: voter.guid,
            ballotId: ballot.id,
            isAttending: !isProxy,
            proxyEmail: proxyEmail
        })
            .then((response) => {
                if (response.data.isSuccessful) {
                    setSuccessMsg("Proxy preferences successfully submitted")
                    setJustSubmitted(true)
                }
                else {
                    setErrorMsg(response.data.errorMessage)
                }

                setSubmitting(false)
            })
            .catch(function (error) {
                alert(error)
            })
    }

    const isReadOnly = voter.proxySubmitDate || isJustSubmitted

    return (
        <div>
            {errorMsg && <ErrorBanner isSticky={true}>{errorMsg}</ErrorBanner>}
            {successMsg && <SuccessBanner isSticky={true}>{successMsg}</SuccessBanner>}
            {voter.proxySubmitDate && <SuccessBanner isSticky={true}>Submitted: {voter.proxySubmitDateFormated}</SuccessBanner>}
            <div className="mb-4">
                <h2>{voter.name}</h2>
            </div>
            <div>{proxyInfo.proxyPreferenceStatement || 'Please select your proxy preference for the upcoming ballot'}</div>
            <div className="mb-4">
                <label>
                    <input
                        type="radio"
                        name="attendance"
                        value="attending"
                        disabled={isReadOnly}
                        checked={!isProxy}
                        onChange={handleOptionChange}
                    />
                    {proxyInfo.proxyPreferenceAttendText || 'I am attending the ballot'}
                </label>
            </div>
            <div className="mb-4">
                <label>
                    <input
                        type="radio"
                        name="attendance"
                        value="proxy"
                        disabled={isReadOnly}
                        checked={isProxy}
                        onChange={handleOptionChange}
                    />
                    {proxyInfo.proxyPreferenceNominateText || 'I am nominating a proxy'}
                </label>
            </div>

            <div className="mb-4">
                <label>
                    {proxyInfo.proxyPreferenceEmailLabel || 'Proxy Email:'}
                    <input
                        type="email"
                        value={proxyEmail}
                        disabled={isReadOnly}
                        onChange={handleEmailChange}
                        placeholder="Enter proxy's email"
                    />
                </label>
            </div>

            {!isReadOnly && <LoadingButton className="btn"
                onBtnClick={handleSubmit}
                btnText="Submit"
                isLoading={isSubmitting}
                isSubmit={true}
                isDisabled={isPreview}
                confirmText="Are you sure you want to submit your proxy preferences?" />}
        </div>
    );
}